module.exports = __webpack_public_path__ + "b688a55e99eed2305aba55362b930ee8.svg";